export { default as TextArea } from './TextArea';
export type { TextAreaProps } from './types';
